import { PropsWithChildren, useEffect } from 'react';
import { datadogRum } from '@datadog/browser-rum';

const DatadogForceSession = ({ children }: PropsWithChildren) => {
  useEffect(() => {
    datadogRum.startSessionReplayRecording({ force: true });
  }, []);

  return <>{children}</>;
};

export default DatadogForceSession;
